import { render } from "./StudyAuditLogs.vue?vue&type=template&id=58856209&scoped=true"
import script from "./StudyAuditLogs.vue?vue&type=script&lang=js"
export * from "./StudyAuditLogs.vue?vue&type=script&lang=js"

import "./StudyAuditLogs.vue?vue&type=style&index=0&id=58856209&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58856209"]])

export default __exports__